import { lazy, Suspense } from 'react';
import { Navigate, Routes, Route } from 'react-router-dom';

const AdminDashboard = lazy(() => import('./screens/AdminDashboard'));
const WalletApp = lazy(() => import('./screens/WalletApp'));
const WalletSharePopup = lazy(() => import('./screens/WalletSharePopup'));
const GeonorgePortal = lazy(() => import('./screens/GeonorgePortal'));

export function IgaGeonorgeApp() {
  return (
    <Suspense fallback={<div role="status">Loading…</div>}><Routes>
      <Route path="/" element={<AdminDashboard />} />
      <Route path="/wallet" element={<WalletApp />} />
      <Route path="/wallet/share" element={<WalletSharePopup />} />
      <Route path="/geonorge" element={<GeonorgePortal />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes></Suspense>
  );
}
